import { List, OrderedMap } from 'immutable'

import { toString } from './helpers'

const getKey = (obj: any, array: any[]) => array.reduce((acc, key) => acc[key], obj)

// @todo better types for iterables
export const reduceIntoMap = (
  data: any = List(),
  transform?: (x: any, i?: number) => any,
  initial = OrderedMap(),
  key = ['id'],
) =>
  data
    ? data.reduce(
        (acc: any, x: any, i: number) => acc.set(toString(getKey(x, key)) || i, transform ? transform(x, i) : x),
        initial,
      )
    : initial

export const reduceIntoList = (data: any = List(), transform?: (x: any, i?: number) => any) =>
  data ? data.reduce((acc: any, x: any, i: number) => acc.push(transform ? transform(x, i) : x), List()) : List()

export const reduceIntoArray = (data: any = List(), transform?: (x: any, i?: number) => any) =>
  reduceIntoList(data, transform).toArray()

export const reduceObjectIntoMap = (
  data: Record<any, any> | null = {},
  transform?: (x: any, i?: number) => any,
  initial = OrderedMap(),
) =>
  data
    ? Object.keys(data).reduce(
        (acc, x) => (Object.hasOwn(data, x) ? acc.set(x, transform ? transform(data[x]) : data[x]) : acc),
        initial,
      )
    : initial

export const reduceObjectIntoList = (data: Record<any, any> = {}, transform?: (x: any, i?: number) => any) =>
  data
    ? reduceIntoList(
        Object.keys(data).reduce(
          (acc, x) => (Object.hasOwn(data, x) ? acc.push({ key: x, value: data[x] }) : acc),
          List(),
        ),
        transform,
      )
    : List()
